import { ChangeDetectionStrategy, Component, effect, inject, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import type { MitMandateDTO } from '../../core/models';
import { MitService, mitApiError } from '../../services/mit.service';

/** Regenera la liga de registro de un mandato pendiente o vencido por registro; conserva su primer cobro. */
@Component({
  selector: 'app-mit-mandate-link-dialog',
  templateUrl: './mit-mandate-link-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule]
})
export class MitMandateLinkDialogComponent {
  private mitService = inject(MitService);

  mandate = input<MitMandateDTO | null>(null);
  visible = input(false);
  closed = output<void>();
  changed = output<MitMandateDTO>();

  saving = signal(false);
  error = signal<string | null>(null);
  issued = signal<MitMandateDTO | null>(null);

  constructor() {
    effect(() => {
      if (!this.visible()) return;
      this.issued.set(null);
      this.error.set(null);
    });
  }

  close(): void {
    if (!this.saving()) this.closed.emit();
  }

  issue(): void {
    const mandate = this.mandate();
    if (!mandate || this.saving()) return;
    this.saving.set(true);
    this.error.set(null);
    this.mitService.regenerateEnrollmentLink(mandate.id).subscribe({
      next: (response) => {
        this.saving.set(false);
        this.issued.set(response.body ?? null);
        if (response.body) this.changed.emit(response.body);
      },
      error: (err) => {
        this.saving.set(false);
        this.error.set(mitApiError(err, 'No se pudo emitir la liga').message);
      }
    });
  }
}
